module.exports = __webpack_public_path__ + "static/banner-mb-02-62d8042d29b468d49878ebba77902ef7.jpg";